import * as React from "react";

const s = require("./Scroll.scss");

interface IScrollProps {};

interface IScrollState {};

class Scroll extends React.Component<IScrollProps, IScrollState> {
    public render(): JSX.Element {
        return (
            <div className={s.scrollWrapper}>
                <div className={s.scrollable}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Scroll;



// WEBPACK FOOTER //
// ./src/components/Scroll/index.tsx